import { AxiosResponse } from "axios";
import request from "configs/request";

const getContactList = (): Promise<AxiosResponse> => {
  return request.get("/get_contact_us_list.php");
};

export default {
  getContactList,
};
